
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.945.305c1.12 0 2.151.258 3.094.773a5.496 5.496 0 012.211 2.18c.537.937.805 1.995.805 3.172 0 1.146-.26 2.187-.782 3.125a5.601 5.601 0 01-2.203 2.203c-.942.531-1.984.797-3.125.797-1.135 0-2.177-.263-3.125-.79A5.563 5.563 0 011.625 9.57c-.52-.937-.781-1.984-.781-3.14 0-1.172.265-2.227.797-3.164a5.563 5.563 0 012.203-2.188C4.78.562 5.815.305 6.945.305zm.547 11.133a4.683 4.683 0 001.938-.618 4.382 4.382 0 001.718-1.804c.334-.63.53-1.32.586-2.07H7.492v4.492zm3.64-7.618a4.384 4.384 0 00-1.726-1.797 4.741 4.741 0 00-1.914-.601v4.484h4.242a5.268 5.268 0 00-.601-2.086zm-4.75 3.125H2.157c.063.756.26 1.448.594 2.078a4.5 4.5 0 001.734 1.797 4.796 4.796 0 001.899.617V6.946zm0-1.039V1.422a4.644 4.644 0 00-1.89.61 4.451 4.451 0 00-1.726 1.796 5.352 5.352 0 00-.61 2.078h4.227z","fill":"currentColor"}})])
          )
        }
      }
    